// Tiny global bus so transient popups (nudges, notification dropdowns) can
// react when the main menu opens. Rule: no popup/bubble may sit over the menu.
export const MENU_EVENT = "dharmartha:menu";

export function setMenuOpen(open) {
  if (typeof window === "undefined") return;
  window.__dhMenuOpen = !!open;
  window.dispatchEvent(new CustomEvent(MENU_EVENT, { detail: { open: !!open } }));
}

export function isMenuOpen() {
  return typeof window !== "undefined" && !!window.__dhMenuOpen;
}

// Subscribe to menu-open events; calls fn(open). Returns an unsubscribe fn.
export function onMenu(fn) {
  if (typeof window === "undefined") return () => {};
  const handler = (e) => fn(!!e.detail?.open);
  window.addEventListener(MENU_EVENT, handler);
  return () => window.removeEventListener(MENU_EVENT, handler);
}
